module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MediaGrid"
  }, _vm._l((_vm.media), function(item, index) {
    return _c('div', {
      staticClass: "MediaGrid-item",
      attrs: {
        "id": item.hash
      }
    }, [(item.title) ? _c('h2', {
      staticClass: "MediaGrid-title t-heading-md",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
      staticClass: "MediaGrid-description t-text-sm"
    }, [_c('markdown', {
      attrs: {
        "content": item.description
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm._l((item.sections), function(section, index) {
      return (item.sections) ? _c('div', {
        staticClass: "MediaGrid-section",
        attrs: {
          "id": _vm.sectionId(section)
        }
      }, [(section.title) ? _c('h2', {
        staticClass: "MediaGrid-sectionTitle t-caps-lg",
        domProps: {
          "innerHTML": _vm._s(section.title)
        }
      }) : _vm._e(), _vm._v(" "), (section.items) ? _c('grid', _vm._l((section.items), function(cell, index) {
        return _c('grid-item', {
          key: index,
          class: _vm.gridItemClasses(cell),
          style: (_vm.gridItemStyles(cell)),
          attrs: {
            "span": cell.span
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleItemClick(cell.hash)
            }
          }
        }, [(cell.type !== 'multi') ? _c('article', [_c(("media-grid-item-" + (cell.type)), {
          tag: "component",
          attrs: {
            "data": cell,
            "span": cell.span
          }
        })], 1) : _vm._e(), _vm._v(" "), (cell.type === 'multi') ? _c('article', [_c('grid', _vm._l((cell.items), function(item, index) {
          return _c('grid-item', {
            key: index,
            class: item.class,
            style: (item.style),
            attrs: {
              "span": item.span,
              "order": item.order
            }
          }, [(item.type !== 'multi') ? _c(("media-grid-item-" + (item.type)), {
            tag: "component",
            attrs: {
              "data": item
            }
          }) : _vm._e()], 1)
        }), 1)], 1) : _vm._e()])
      }), 1) : _vm._e()], 1) : _vm._e()
    })], 2)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2969b19b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaGrid.vue
// module id = 751
// module chunks = 1474